export const enum EventType {
  ROW_SAVE = "row:save",
  ROW_UPDATE = "row:update",
  ROW_DELETE = "row:delete",
  TABLE_SAVE = "table:save",
  TABLE_UPDATED = "table:updated",
  TABLE_DELETE = "table:delete",
}
